import { useContext } from 'react';
import PropTypes from 'prop-types';

import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import css from './action-alert.module.scss';

const ActionAlert = ({ localizedText, iconClassName }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <div data-testid="actionAlert" className={css.container}>
      <p className={css.localizedText}>{getLocalizedText(localizedText)}</p>
      <i className={iconClassName} />
    </div>
  );
};

ActionAlert.propTypes = {
  localizedText: PropTypes.string.isRequired,
  iconClassName: PropTypes.string.isRequired,
};

export default ActionAlert;
